
import { Link }from "react-router-dom";
import "../../Styles/Loginpage/Loginpage.css";


export default function LoginPageUsingEmailPass() {
 


  return (
   
      <div className="login-card id-pass-login">
        <img src="/static/media/logo.25ae0241f5bf7d7c5384da9376d392bc.svg" alt="YellowCalf Logo" className="login-logo" />

        <h4 className="mt-3 mb-3">Sign in to your account</h4>

        <hr className="divider" />

        <form>
          <div className="form-group mb-2">
            <input
              type="email"
              className="form-control"
              placeholder="Email ID"
               required
            />
          </div>

          <div className="form-group mb-2 position-relative">
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              required
            />
            <Link to="#" className="forgot-password small">
              I forgot my password
            </Link>
          </div>

          <div className="d-flex gap-3 mb-3 small">
            <Link to="/loginpage" className="text-primary">
              <i className="bi bi-phone"></i> Login Using OTP
            </Link>
            <Link to="/parentlogin" className="text-primary d-flex">
              <i className="bi bi-person-plus"></i> Register as Parent
            </Link>
             <Link to="/accountant" type="submit" className="btn custom-btn main-login">
              Login <i className="bi bi-arrow-right-circle"></i>
            </Link>

          </div>

         
        </form>

        <p className="text-center mt-3 mb-0 small"> 2025 © YellowCafl</p>
      </div>
   
  );
}
